import * as React from 'react';

import styled from 'styled-components';

export interface InstagramIconProps {
  className?: string;
  viewBox?: string;
}

export const InstagramIcon: React.FC<InstagramIconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <Path d="M10.9 15H4.1C1.8 15 0 13.2 0 10.9V4.1C0 1.8 1.8 0 4.1 0h6.8C13.2 0 15 1.8 15 4.1v6.8C15 13.2 13.2 15 10.9 15zM4.1 1.4c-1.5 0-2.7 1.2-2.7 2.7v6.8c0 1.5 1.2 2.7 2.7 2.7h6.8c1.5 0 2.7-1.2 2.7-2.7V4.1c0-1.5-1.2-2.7-2.7-2.7H4.1z" />
    <Path d="M7.5 10.9c-0.9 0-1.7-0.3-2.4-1 -1-1-1.3-2.6-0.6-3.9C5.2 4.6 6.6 3.9 8 4.1c1.5 0.2 2.7 1.4 2.9 2.9 0.2 1.5-0.5 2.9-1.8 3.6C8.6 10.8 8.1 10.9 7.5 10.9zM7.5 5.4c-0.8 0-1.5 0.4-1.8 1.1 -0.4 0.8-0.2 1.7 0.4 2.4C6.7 9.5 7.7 9.7 8.5 9.3c0.8-0.4 1.2-1.2 1.1-2.1l0 0c-0.1-0.9-0.8-1.6-1.7-1.7C7.7 5.4 7.6 5.4 7.5 5.4z" />
  </svg>
);

export default InstagramIcon;

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.primary};
`;
